const types = {
  PROVIDERS_LIST: "PROVIDERS_LIST",
  PROVIDERS_LIST_RESPONSE: "PROVIDERS_LIST_RESPONSE",
  PROVIDERS_LIST_CLEAR: "PROVIDERS_LIST_CLEAR",
  PROVIDER_COURSES_LIST: "PROVIDER_COURSES_LIST",
  PROVIDER_COURSES_LIST_RESPONSE: "PROVIDER_COURSES_LIST_RESPONSE",
  PROVIDER_VIDEOS_LIST: "PROVIDER_COURSES_LIST",
  PROVIDER_VIDEOS_LIST_RESPONSE: "PROVIDER_COURSES_LIST_RESPONSE",
  PROVIDER_CATEGORY_LIST: "PROVIDER_CATEGORY_LIST",
  PROVIDER_CATEGORY_LIST_RESPONSE: "PROVIDER_CATEGORY_LIST_RESPONSE",
  PROVIDER_DETAIL: "PROVIDER_DETAIL",
  PROVIDER_DETAIL_RESPONSE: "PROVIDER_DETAIL_RESPONSE",

  PROVIDER_COACHING: "PROVIDER_COACHING",
  PROVIDER_COACHING_RESPONSE: "PROVIDER_COACHING_RESPONSE",
  PROVIDER_COACHING_CLEAR: "PROVIDER_COACHING_CLEAR",

  COACHING_DETAIL: "COACHING_DETAIL",
  COACHING_DETAIL_RESPONSE: "COACHING_DETAIL_RESPONSE",
  COACHING_DETAIL_CLEAR: "COACHING_DETAIL_CLEAR",

  //Global Search Partners
  GLOBAL_SEARCH_PARTNERS: " GLOBAL_SEARCH_PARTNERS",
  GLOBAL_SEARCH_PARTNERS_RESPONSE: " GLOBAL_SEARCH_PARTNERS_RESPONSE",
  GLOBAL_SEARCH_PARTNERS_CLEAR: " GLOBAL_SEARCH_PARTNERS_CLEAR",

   //Global Search Coaching
   GLOBAL_SEARCH_COACHING: " GLOBAL_SEARCH_COACHING",
   GLOBAL_SEARCH_COACHING_RESPONSE: " GLOBAL_SEARCH_COACHING_RESPONSE",
   GLOBAL_SEARCH_COACHING_CLEAR: " GLOBAL_SEARCH_COACHING_CLEAR",
  

};

export default types;
